export const ACCOUNT = 'account';
export const SIGNIN = 'signin';
export const SIGNIN_VERIFICATION = 'verify-signin-otp';
export const LOGOUT = 'logout';

export const DASHBOARD = 'dashboard';
export const INBOX = 'inbox';
export const CUSTOMERS = 'customers';
export const TRANSACTIONS = 'transactions';
export const RISK_CENTER = 'risk-center';
export const RECONCILIATION = 'reconciliation';
export const GIFTS = 'gifts';
export const SCHEDULES = 'schedules';
export const ANALYTICS = 'analytics';
export const SESSIONS = 'sessions';
export const PROFIT = 'profit';
export const LIMITS = 'limits';
export const FEEDBACK = 'feedback';
export const PASSKEYS = 'passkeys';
export const PASSKEY_ENROLL = 'passkeys/enroll';

export const NOTFOUND = '404';
